(() => {
  if (window.nmCatalogueLoaded) return;
  window.nmCatalogueLoaded = true;

  const applyCardSwatch = (card, swatch, announce = true) => {
    card.querySelectorAll('[data-nm-swatch]').forEach((item) => item.removeAttribute('aria-current'));
    swatch.setAttribute('aria-current', 'true');
    card.dataset.nmColour = swatch.dataset.label || '';
    card.querySelectorAll('[data-nm-card-link]').forEach((link) => { link.href = swatch.dataset.url; });
    const picture = card.querySelector('.nm-card__image');
    if (picture && swatch.dataset.image) {
      picture.removeAttribute('srcset');
      picture.src = swatch.dataset.image;
      picture.alt = swatch.dataset.imageAlt || '';
    }
    const review = card.querySelector('[data-nm-card-review]');
    if (review) review.href = `${swatch.dataset.url}#looxReviews`;
    card.querySelectorAll('[data-nm-hover-size]').forEach((button) => { button.hidden = button.dataset.colour !== card.dataset.nmColour; });
    const price = card.querySelector('[data-nm-card-price]');
    if (price) {
      const amount = document.createElement('span');
      amount.textContent = swatch.dataset.price;
      price.replaceChildren();
      if (swatch.dataset.priceVaries === 'true') {
        const from = document.createElement('span');
        from.className = 'nm-card__from';
        from.textContent = swatch.dataset.from;
        price.append(from);
      }
      price.append(amount);
      if (swatch.dataset.compare) {
        const compare = document.createElement('s');
        compare.textContent = swatch.dataset.compare;
        price.append(compare);
      }
    }
    const saleBadge = card.querySelector('[data-nm-card-sale]');
    if (saleBadge) saleBadge.hidden = swatch.dataset.sale !== 'true';
    const badge = card.querySelector('[data-nm-card-badge]');
    if (badge) badge.hidden = swatch.dataset.available === 'true';
    const label = card.querySelector('[data-nm-card-colour]');
    if (label) label.textContent = swatch.dataset.label;
    const status = card.querySelector('[data-nm-card-status]');
    if (status && announce) {
      delete status.dataset.error;
      status.textContent = `${swatch.dataset.label}, ${swatch.dataset.price}`;
    }
    card.dispatchEvent(new CustomEvent('nm:card-colour-change', { bubbles: true }));
  };

  const matchesAvailableVariant = (card, sizes, colours) => card.variants.some((variant) =>
    variant.available && (!sizes.size || sizes.has(variant.size)) && (!colours.size || colours.has(variant.colour))
  );

  const initialiseLocalFilters = (catalogue, form, dialog) => {
    const source = catalogue.querySelector('[data-nm-local-filter-data]');
    if (!source || !form) return () => {};
    let data;
    try { data = JSON.parse(source.textContent); } catch { return () => {}; }
    const products = data.products || [];
    const productById = new Map(products.map((product) => [String(product.id), product]));
    const nativeFilters = new URL(window.location.href).searchParams;
    const minPrice = nativeFilters.get('filter.v.price.gte');
    const maxPrice = nativeFilters.get('filter.v.price.lte');
    const available = nativeFilters.getAll('filter.v.availability');
    const nativeSizes = nativeFilters.getAll('filter.v.option.size');
    const nativeColours = [...nativeFilters.getAll('filter.v.option.color'), ...nativeFilters.getAll('filter.v.option.colour')];
    const passesNative = (variant) => {
      if (available.length === 1 && String(Number(variant.available)) !== available[0]) return false;
      if (nativeSizes.length && !nativeSizes.includes(variant.size)) return false;
      if (nativeColours.length && !nativeColours.includes(variant.colour)) return false;
      if (minPrice && variant.amount < Number(minPrice) * 100) return false;
      if (maxPrice && variant.amount > Number(maxPrice) * 100) return false;
      return true;
    };
    const cards = Array.from(catalogue.querySelectorAll('[data-nm-card][data-nm-product-id]'), (element) => {
      const product = productById.get(String(element.dataset.nmProductId));
      const colour = element.dataset.nmColour;
      const productVariants = (product?.variants || []).filter((variant) => (!data.saleOnly || variant.discounted) && passesNative(variant));
      return { element, originalColour: colour, productVariants, variants: productVariants.filter((variant) => element.dataset.nmColourCard !== 'true' || variant.colour === colour) };
    });
    const groups = form.querySelector('.nm-filter-groups');
    if (!products.length || !groups) return () => {};
    const labels = data.labels;
    const controller = new AbortController();
    const sizes = new Set();
    const colours = new Set();
    const options = { size: [], colour: [] };
    const dimensions = [
      { key: 'size', parameter: 'nm_size', enabled: data.sizeEnabled, selected: sizes, label: labels.size, order: 1 },
      { key: 'colour', parameter: 'nm_color', enabled: data.colourEnabled, selected: colours, label: labels.colour, order: 2 }
    ];
    const nativeSignature = () => JSON.stringify(Array.from(new FormData(form)).filter(([key, value]) => !key.startsWith('nm_') && value !== '').sort(([a, av], [b, bv]) => a.localeCompare(b) || String(av).localeCompare(String(bv))));
    const initialNativeSignature = nativeSignature();
    const retainedSelections = document.createElement('div');
    retainedSelections.hidden = true;
    form.append(retainedSelections);
    const readLocation = () => {
      const current = new URL(window.location.href);
      dimensions.forEach((dimension) => {
        dimension.selected.clear();
        if (dimension.enabled) current.searchParams.getAll(dimension.parameter).forEach((value) => dimension.selected.add(value));
      });
    };
    const colourStyles = new Map();
    catalogue.querySelectorAll('[data-nm-swatch]').forEach((swatch) => {
      const dot = swatch.querySelector('span');
      if (dot && !colourStyles.has(swatch.dataset.label)) colourStyles.set(swatch.dataset.label, dot.getAttribute('style'));
    });
    products.forEach((product) => {
      if (product.inferredColour && product.inferredColourStyle && !colourStyles.has(product.inferredColour)) {
        colourStyles.set(product.inferredColour, product.inferredColourStyle);
      }
    });
    const originalFirstGroup = groups.firstElementChild;
    dimensions.forEach((dimension) => {
      if (!dimension.enabled) return;
      const values = [...new Set(cards.flatMap((card) => card.variants.map((variant) => variant[dimension.key])).filter(Boolean))];
      if (!values.length) return;
      if (dimension.key === 'size') {
        const order = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL'];
        values.sort((a, b) => {
          const ai = order.indexOf(a.toUpperCase()), bi = order.indexOf(b.toUpperCase());
          if (ai >= 0 && bi >= 0) return ai - bi;
          return a.localeCompare(b, undefined, { numeric: true });
        });
      }
      const group = document.createElement('fieldset');
      group.className = `nm-filter-group nm-filter-group--${dimension.key}`;
      group.dataset.nmLocalGroup = dimension.key;
      group.style.setProperty('--nm-filter-order', dimension.order);
      const legend = document.createElement('legend');
      legend.textContent = dimension.label;
      const list = document.createElement('div');
      list.className = 'nm-filter-values';
      values.forEach((value, index) => {
        const label = document.createElement('label');
        label.className = 'nm-filter-value';
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.name = dimension.parameter;
        input.value = value;
        input.id = `NMLocal-${catalogue.dataset.sectionId}-${dimension.key}-${index}`;
        input.dataset.nmLocalOption = dimension.key;
        label.htmlFor = input.id;
        label.append(input);
        if (dimension.key === 'colour') {
          const colour = document.createElement('span');
          colour.className = 'nm-filter-colour';
          const style = colourStyles.get(value);
          if (style) colour.setAttribute('style', style);
          colour.setAttribute('aria-hidden', 'true');
          label.append(colour);
        }
        const text = document.createElement('span');
        text.className = 'nm-filter-value__label';
        text.textContent = value;
        const count = document.createElement('span');
        count.className = 'nm-filter-value__count nm-sr-only';
        label.append(text, count);
        list.append(label);
        options[dimension.key].push({ input, count, value });
      });
      group.append(legend, list);
      if (dimension.key === 'colour' && values.length > 6) {
        group.dataset.nmColoursCollapsed = 'true';
        list.id = `NMColourValues-${catalogue.dataset.sectionId}`;
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'nm-filter-show-more';
        toggle.setAttribute('aria-controls', list.id);
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = labels.showMore;
        const updateExpansion = () => {
          const expanded = group.dataset.nmColoursCollapsed === 'false';
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? labels.showLess : labels.showMore;
          options.colour.forEach(({ input }, index) => { input.closest('label').hidden = !expanded && index >= 6 && !input.checked; });
        };
        toggle.addEventListener('click', () => {
          group.dataset.nmColoursCollapsed = group.dataset.nmColoursCollapsed === 'true' ? 'false' : 'true';
          updateExpansion();
        }, { signal: controller.signal });
        group.append(toggle);
        updateExpansion();
      }
      groups.insertBefore(group, originalFirstGroup);
    });
    const selectedUrl = (sourceUrl = window.location.href, omitDimension, omitValue) => {
      const url = new URL(sourceUrl, window.location.origin);
      dimensions.forEach((dimension) => {
        url.searchParams.delete(dimension.parameter);
        dimension.selected.forEach((value) => {
          if (dimension.key !== omitDimension || value !== omitValue) url.searchParams.append(dimension.parameter, value);
        });
      });
      return url;
    };
    const writeLocation = () => {
      const next = selectedUrl();
      if (next.href !== window.location.href) history.pushState(history.state, '', next);
    };
    const render = () => {
      const hasSelection = sizes.size || colours.size;
      let count = 0;
      cards.forEach((card) => {
        if (hasSelection && card.element.dataset.nmColourCard === 'true' && card.element.dataset.nmColour !== card.originalColour) {
          const original = Array.from(card.element.querySelectorAll('[data-nm-swatch]')).find((swatch) => swatch.dataset.label === card.originalColour);
          if (original) applyCardSwatch(card.element, original, false);
        }
        const visible = card.variants.length > 0 && (!hasSelection || matchesAvailableVariant(card, sizes, colours));
        card.element.hidden = !visible;
        if (visible) count += 1;
      });
      dimensions.forEach((dimension) => {
        options[dimension.key].forEach(({ input, count: countNode, value }, index) => {
          const matching = cards.filter((card) => matchesAvailableVariant(card, dimension.key === 'size' ? new Set([value]) : sizes, dimension.key === 'colour' ? new Set([value]) : colours)).length;
          input.checked = dimension.selected.has(value);
          if (dimension.key === 'colour' && input.closest('[data-nm-colours-collapsed]')) input.closest('label').hidden = index >= 6 && !input.checked && input.closest('[data-nm-colours-collapsed]').dataset.nmColoursCollapsed === 'true';
          input.disabled = matching === 0 && !input.checked;
          countNode.textContent = `(${matching})`;
        });
      });
      retainedSelections.replaceChildren();
      dimensions.forEach((dimension) => dimension.selected.forEach((value) => {
        if (options[dimension.key].some((option) => option.value === value)) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = dimension.parameter;
        input.value = value;
        retainedSelections.append(input);
      }));
      const total = catalogue.querySelector('[data-nm-local-count]');
      if (total) total.textContent = count === 1 ? labels.countOne : labels.countMany.replace('0', String(count));
      const empty = catalogue.querySelector('[data-nm-local-empty]');
      if (empty) empty.hidden = count > 0;
      const submit = form.querySelector('.nm-filter-submit button');
      if (submit) submit.textContent = labels.show.replace('__COUNT__', String(count));
      catalogue.querySelectorAll('[data-nm-local-chips]').forEach((container) => {
        container.replaceChildren();
        if (!hasSelection) return;
        container.className = 'nm-filter-chips';
        container.setAttribute('aria-label', labels.active);
        dimensions.forEach((dimension) => dimension.selected.forEach((value) => {
          const chip = document.createElement('a');
          chip.className = 'nm-filter-chip';
          chip.href = selectedUrl(window.location.href, dimension.key, value).href;
          chip.dataset.nmRemoveLocal = dimension.key;
          chip.dataset.nmRemoveValue = value;
          chip.setAttribute('aria-label', labels.remove.replace('__NAME__', `${dimension.label}: ${value}`));
          chip.append(document.createTextNode(`${dimension.label}: ${value} `));
          const cross = document.createElement('span');
          cross.textContent = '×';
          cross.setAttribute('aria-hidden', 'true');
          chip.append(cross);
          container.append(chip);
        }));
        const clear = document.createElement('a');
        clear.className = 'nm-filter-clear';
        clear.href = data.clearUrl;
        clear.dataset.nmLocalClear = '';
        clear.textContent = labels.clear;
        container.append(clear);
      });
      catalogue.querySelectorAll('.nm-filter-chip:not([data-nm-remove-local])').forEach((link) => { link.href = selectedUrl(link.href).href; });
    };
    form.addEventListener('change', (event) => {
      const input = event.target.closest('[data-nm-local-option]');
      if (!input) return;
      const dimension = dimensions.find((item) => item.key === input.dataset.nmLocalOption);
      if (input.checked) dimension.selected.add(input.value);
      else dimension.selected.delete(input.value);
      writeLocation();
      render();
    }, { signal: controller.signal });
    catalogue.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-nm-remove-local]');
      const clear = event.target.closest('[data-nm-local-clear]');
      if (!chip && !clear || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (clear) {
        const nativeFilters = Array.from(new URL(window.location.href).searchParams.keys()).some((key) => key.startsWith('filter.'));
        if (nativeFilters) return;
        sizes.clear();
        colours.clear();
        form.querySelectorAll('input[name^="filter."]').forEach((input) => {
          if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
          else input.value = '';
        });
      } else {
        dimensions.find((item) => item.key === chip.dataset.nmRemoveLocal)?.selected.delete(chip.dataset.nmRemoveValue);
      }
      event.preventDefault();
      writeLocation();
      render();
    }, { signal: controller.signal });
    form.addEventListener('submit', (event) => {
      if (nativeSignature() !== initialNativeSignature) return;
      event.preventDefault();
      writeLocation();
      render();
      if (dialog?.open) dialog.close();
    }, { signal: controller.signal });
    window.addEventListener('popstate', () => { readLocation(); render(); }, { signal: controller.signal });
    readLocation();
    render();
    return () => controller.abort();
  };

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-nm-catalogue]').forEach((catalogue) => {
      if (catalogue.dataset.nmReady) return;
      catalogue.dataset.nmReady = 'true';
      const form = catalogue.querySelector('[data-nm-filter-form]');
      const home = catalogue.querySelector('[data-nm-filter-home]');
      const dialog = catalogue.querySelector('[data-nm-filter-dialog]');
      const mount = catalogue.querySelector('[data-nm-filter-mount]');
      const opener = catalogue.querySelector('[data-nm-filter-open]');
      const close = catalogue.querySelector('[data-nm-filter-close]');
      const sort = catalogue.querySelector('[data-nm-sort]');
      if (sort) {
        sort.addEventListener('change', () => sort.form?.requestSubmit());
        catalogue.classList.add('nm-catalogue--enhanced');
      }
      const destroyLocal = initialiseLocalFilters(catalogue, form, dialog);
      catalogue.nmDestroy = destroyLocal;
      if (!form || !home || !dialog || !mount || !opener || typeof dialog.showModal !== 'function') return;
      const controller = new AbortController();
      let previousOverflow = '';
      let returnFocus = null;
      const relocate = () => { if (form.parentElement !== mount) mount.append(form); };
      opener.addEventListener('click', () => {
        returnFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
        relocate();
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        close.focus();
      }, { signal: controller.signal });
      close.addEventListener('click', () => dialog.close(), { signal: controller.signal });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }, { signal: controller.signal });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        if (returnFocus?.isConnected) returnFocus.focus();
      }, { signal: controller.signal });
      catalogue.classList.add('nm-catalogue--modal-ready');
      relocate();
      catalogue.nmDestroy = () => {
        if (dialog.open) dialog.close();
        controller.abort();
        destroyLocal();
      };
    });
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-nm-swatch]');
    if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    const card = swatch.closest('[data-nm-card]');
    if (!card) return;
    event.preventDefault();
    if (card.getAttribute('aria-busy') === 'true') return;
    applyCardSwatch(card, swatch);
  });
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-nm-catalogue]').forEach((catalogue) => catalogue.nmDestroy?.()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
})();
